import React, { useEffect } from "react";

interface IProps {
  id?: string;
  className?: string;
  children: React.ReactNode | React.ReactNode[];
  justify?: React.CSSProperties["justifyContent"];
  align?: React.CSSProperties["alignItems"];
  direction?: React.CSSProperties["flexDirection"];
  wrap?: React.CSSProperties["flexWrap"];
  style?: React.CSSProperties;
  gap?: number;
  padding?: string | number;
  onClick?: (event?: any) => void;
  onMouseDown?: (event?: any) => void;
  onMouseEnter?: (event?: any) => void;
  onMouseLeave?: (event?: any) => void;
  onMousedown?: (event?: any) => void;
  onWheel?: (event?: any) => void;
  nativeEventStop?: boolean;
}

function FTFlex(props: IProps, ref: React.Ref<HTMLDivElement>) {
  const {
    children,
    justify,
    align,
    direction,
    wrap,
    style,
    className,
    gap = 0,
    padding = 0,
    onClick,
    onMousedown,
    onWheel,
    nativeEventStop = false,
    id,
    ...rest
  } = props;

  return (
    <div
      className={className}
      ref={ref}
      id={id}
      style={{
        display: "flex",
        justifyContent: justify || "flex-start",
        alignItems: align || "flex-start",
        flexDirection: direction || "row",
        flexWrap: wrap || "nowrap",
        gap: (gap || 0) + "px",
        zIndex: 1,
        // padding: typeof padding === "number" ? padding + "px" : padding,
        ...(padding
          ? {
              padding: typeof padding === "number" ? padding + "px" : padding,
            }
          : {}),
        ...style,
      }}
      onClick={onClick}
      onMouseDown={onMousedown}
      onWheel={onWheel}
      {...rest}
    >
      {children}
    </div>
  );
}
const FTFlexRef = React.forwardRef(FTFlex);
export default FTFlexRef;
